/**
 * Web stub for react-native-redash
 */
import React, { FC } from 'react';

const ReText: FC<any> = ({ text, ...props }) => {
  return React.createElement('span', props, text);
};

export { ReText };
export default ReText;
